import { Card, Stack, Typography } from "@mui/material";
import React from "react";
import { fontSizes } from "../../../theme";
import HalfPieChart from "./HalfPieChart";

const HalfPieCard: React.FC<{
  title: string;
  labels: [string, string];
  rate: number;
}> = ({ title, labels, rate }) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "left",
        padding: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
      }}
    >
      <Typography width={"100%"} textAlign={"left"} variant="medium" fontSize={fontSizes.lg}>
        {title}
      </Typography>
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        direction="row"
        gap={2}
      >
        <HalfPieChart width={120} height={60} labels={labels} rate={rate} />
      </Stack>
    </Card>
  );
};

export default HalfPieCard;
